import { useController } from "react-hook-form";
import cns from "classnames";
import { Box, Typography, makeStyles } from "@material-ui/core";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import { Color } from "@bonliva-crm/ui";
import { FilterWithFavouriteProps } from "../../utils/filters-record-types";
import { NonCollapsibleFavFilter } from "../_base/non-collapsible-fav-filter";
import React from "react";

export type ToggleBtnFilterProps = {
  label: string;
  options: {
    value: string | null;
    label: React.ReactNode;
  }[];
} & FilterWithFavouriteProps;

export const ToggleBtnFilter = ({ label, options, ...props }: ToggleBtnFilterProps) => {
  const classes = useStyles();

  const { field, fieldState } = useController({ name: props.name });

  const renderOptions =
    options?.map((option) => (
      <ToggleButton key={option.value} value={option.value}>
        {option.label}
      </ToggleButton>
    )) ?? null;

  if (props.setFavorite) {
    return (
      <NonCollapsibleFavFilter
        title={label}
        isDirty={fieldState.isDirty}
        isClearable={false}
        action={
          <Box pr={1}>
            <ToggleButtonGroup
              value={field?.value}
              exclusive
              onChange={(e, v) => field.onChange(v)}
            >
              {renderOptions}
            </ToggleButtonGroup>
          </Box>
        }
        favorite={props.favorite}
        onSetFavorite={props.setFavorite}
      />
    );
  }

  return (
    <span className={cns(classes.root, classes.border)}>
      <Typography variant="body1" style={{ color: Color.DetailsInput }}>
        {label}
      </Typography>

      <div>
        <ToggleButtonGroup
          size="small"
          value={field?.value}
          exclusive
          onChange={(e, v) => field.onChange(v)}
        >
          {renderOptions}
        </ToggleButtonGroup>
      </div>
    </span>
  );
};

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0.5rem 0.75rem",
    gap: "0.5rem"
  },
  border: {
    border: `1px solid ${Color.LightGray}`,
    borderRadius: "4px"
  }
}));
